import React, { lazy, Suspense } from 'react';

import { useQuery, useApolloClient } from '@apollo/client';

import { GET_INFOUSER } from '@betwixt/common/graphql/user.js';

const ModulesEmitters = (props) => {
  const { data, loading, error } = useQuery(GET_INFOUSER);
  const client = useApolloClient();
  const User = data?.User;

  if (loading) return null;
  if (error) {
    console.error('ModulesEmitters query error:', error);
    return null;
  }
  if (!User) return null;

  const getAllListening = () => {
    if (!User.modulesActived) return null;

    return User.modulesActived.map((item, index) => {
      if (
        item.module &&
        item.module.options &&
        item.module.options.emitters &&
        item.module.options.emitters.my === true
      ) {
        try {
          const Folder = item.routes && item.routes.my.path ? item.routes.my.path : item.module.id;
          const Component = lazy(() => import(`@betwixt/common/modules/${Folder}/my/Emitters`));
          /*
                    const resource = require(`@betwixt/common/modules/${Folder}/translation/${i18n.language}.json`)    
                    i18n.addResourceBundle(i18n.language, `${item.module.id}`, resource, true, true)
                    */
          return (
            <div className={`emitters ${item.module.id}-emitters`} key={index}>
              <Component key={index} {...props} {...item} User={User} client={client} />
            </div>
          );
        } catch (err) {
          console.error('Error loading emitter:', err);
          return null;
        }
      }
      return null;
    });
  };

  return (
    <div>
      <Suspense fallback={<div>Loading...</div>}>{getAllListening()}</Suspense>
    </div>
  );
};

export default ModulesEmitters;
